import React, { FC, forwardRef, useCallback, useMemo, useState } from 'react'

import { NavMenuProps } from '../NavMenu'
import NavPush from '../NavPush'

import * as SC from './styled'

export type NavMegaMenuProps = NavMenuProps & {
  className?: string
  levelOne: number
  onLeaveHandler?: () => void
}

const NavMegaMenu: FC<NavMegaMenuProps> = forwardRef(function NavMegaMenu(
  props,
  ref
) {
  const { className, links, levelOne, onLeaveHandler } = props

  const [isStateOpen] = useState(levelOne >= 0)
  const [currentLevelTwo, setCurrentLevelTwo] = useState<any>(null)

  const handleOverLevelTwo = useCallback((index) => {
    setCurrentLevelTwo(null)
    setTimeout(() => {
      setCurrentLevelTwo(index)
    }, 5)
  }, [])

  const handleLeave = useCallback(() => {
    setCurrentLevelTwo(null)
    onLeaveHandler && onLeaveHandler()
  }, [onLeaveHandler, setCurrentLevelTwo])

  const renderPush = useMemo(() => {
    const pushItem = links?.[levelOne]?.push
    return pushItem ? <NavPush {...pushItem} /> : null
  }, [links, levelOne])

  const renderLevelTwo = useMemo(() => {
    const levelTwoItems = links?.[levelOne]?.levelTwo
    return levelTwoItems ? (
      <SC.LinksTwo>
        {levelTwoItems?.map((item, index) => (
          <SC.LinksTwoItem
            key={`menu-lvl2-${index}`}
            onMouseEnter={() => handleOverLevelTwo(index)}
          >
            <SC.LinksTwoLink
              {...item.link}
              isHovered={index === currentLevelTwo}
            >
              {item.link?.text && <span>{item.link?.text}</span>}
              {item.levelThree && <SC.LinksTwoIcon icon="chevronRight" />}
            </SC.LinksTwoLink>
          </SC.LinksTwoItem>
        ))}
      </SC.LinksTwo>
    ) : null
  }, [links, levelOne, currentLevelTwo, handleOverLevelTwo])

  const levelThreeItems = useMemo(
    () => links?.[levelOne]?.levelTwo?.[currentLevelTwo]?.levelThree,
    [currentLevelTwo, levelOne, links]
  )

  const renderLevelThree = useMemo(() => {
    return levelThreeItems ? (
      <SC.PanelThree hasItems={!!levelThreeItems}>
        <SC.LinksThree>
          {levelThreeItems?.map((item) => (
            <SC.LinksThreeItem key={`menu-lvl3-${item.link?.text}`}>
              <SC.LinksThreeLink {...item.link}>
                {item.link?.text && <span>{item.link?.text}</span>}
              </SC.LinksThreeLink>
            </SC.LinksThreeItem>
          ))}
        </SC.LinksThree>
      </SC.PanelThree>
    ) : null
  }, [levelThreeItems])

  return (
    <SC.NavMegaMenuContainer
      className={className}
      isOpen={isStateOpen}
      onMouseLeave={handleLeave}
      ref={ref}
    >
      <SC.NavMegaMenuWrapper>
        <SC.PanelPush>{renderPush}</SC.PanelPush>
        <SC.PanelTwo>{renderLevelTwo}</SC.PanelTwo>
        {renderLevelThree}
      </SC.NavMegaMenuWrapper>
    </SC.NavMegaMenuContainer>
  )
})

export default NavMegaMenu
